import { FormControl, FormLabel, Grid } from "@mui/material";
import React, { useEffect, useState, memo, useCallback } from "react";
import { SelectView } from "../common/selectView/SelectView";
import TextInput from "../common/textInput/TextInput";
import {
  HELPER_TEXT_STYLE,
  NUMBER_FIELD_STYLE,
  RIGHT_ALIGN,
  SUCCESS_TXT,
  MARGIN_TB_ITEMS_SM,
  Name_Validation,
} from "../../utils/GlobalConstants";
import {

  STORE_CREATION_FORM_VALUES,
} from "../../utils/GlobalFormConstants";
import {
  CHAR_ERR,
  DATA_MISS,
  NUMERIC_ERR,
  STORE_NOT_SELECTED,
} from "../../utils/GlobalMessageConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemInJobberData,
  addItemInsurveyData,
} from "../../store/UpdateSurveyData";
import Typo from "../common/typo/Typo";
import {
  getMessages,
  getSelectedState,
  getStatesByCountry,
  onChangeFormInfo,
  validateStoreForm,
} from "../../utils/genericUse/CommonUse";
import {
  createStore,
  createSurvey,
  deleteStore,
  getAllDcCode,
  getAllStore,
  getSingleSurveyDetails,
  getStoreDetails,
} from "../../services/SurveyRequest";
import ButtonLayout from "./ButtonLayout";
import Loader from "../../components/common/dialog/Loader";
import { useTranslation } from "react-i18next";

const StoreCreationForm = (props) => {
  const [selectedJobber, setSelectedJobber] = useState(false);
  const [jobberList, setJobberList] = useState();
  const [jobber, setJobber] = useState();
  const [states, setStates] = useState();
  const [selectedCountry, setSelectedCountry] = useState({
    id: 1,
    name: "USA",
  });
  const [selectedState, setSelectedState] = useState();
  const [error, setError] = useState({});
  const [emailError, setEmailError] = useState(false);
  const [helperText, setHelperText] = useState();
  const [helperStoreText, setStoreHelperText] = useState();
    const [storeText, setStoreText] = useState('');
  const [dcError, setDCError] = useState(false);
  const [storeError, setStoreError] = useState(false);
  const [helperEmailText, setHelperEmailText] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState();
  const [countries, setCountries] = useState();
  const [napaStoreErr, setNapaStoreErr] = useState(false);
  const [dcCodeList, setDcCodeList] = useState([]);
  const [selectedDcCode, setSelectedDcCode] = useState("");
  const [errorList, setErrorList] = useState({
    dcCodeError: { validationErr: false, dataErr: false, message: "" },
  });

  const dispatch = useDispatch();
  const { t } = useTranslation();

  //=== getting selected survey from central store
  const selectedSurveyFromStore = useSelector(
    (state) => state.surveyData?.surveyData
  );
  //=== getting countries from central store
  const countriesFromStore = useSelector(
    (state) => state.surveyData?.countryData?.countries
  );

  useEffect(() => {
    getAllJobbers();
    getDcCode();
  }, []);

  useEffect(() => {
    setSelectedSurvey(selectedSurveyFromStore);
  }, [selectedSurveyFromStore]);

  useEffect(() => {
    setCountries(countriesFromStore);
    if (countriesFromStore && countriesFromStore.length > 0)
      setStates(countriesFromStore[0].states);
  }, [countriesFromStore]);


  const getDcValue = (code) => {
    const dcResult = dcCodeList.find((n) => n.id === code) || null;
    return dcResult;
  };

  const getJobber = useCallback(
    async (id) => {
      try {
        const getStoreData = await getStoreDetails(id);
        setJobber(getStoreData.store);
        //=== setting country states for selected store
        let tempStates;
        if (getStoreData.store.country) {
          let updatedCountryStatesInfo = getStatesByCountry(
            countries,
            getStoreData.store.country
          );
          setSelectedCountry(updatedCountryStatesInfo.selectedCountry);
          tempStates = updatedCountryStatesInfo.tempStates;
          setStates(updatedCountryStatesInfo.tempStates);
        }

        if (getStoreData.store.state) {
          let tempSelectedState = getSelectedState(
            tempStates,
            getStoreData.store.state
          );
          setSelectedState(tempSelectedState);
        }

        setSelectedDcCode(getStoreData.store.dcCode || "");
        //===
      } catch (e) {
        console.log(e);
      }
    },
    [countries]
  );

  useEffect(() => {
    clearingForm();
    if (selectedSurvey && Object.keys(selectedSurvey).length === 0) {
      setJobber({});
      setSelectedState({});
    } else if (selectedSurvey && selectedSurvey.storeId) {
      getJobber(selectedSurvey.storeId);
      setSelectedJobber(true);
    }
  }, [selectedSurvey, getJobber]);

  const getAllJobbers = async () => {
    try {
      const getStoreList = await getAllStore();
      let jobbers = [
        { id: "Add New", storeName: "Add New" },
        ...getStoreList.stores,
      ];
      setJobberList(jobbers);
    } catch (e) {
      console.log(e);
    }
  };

  const clearingForm = () => {
    setError(false);
    setEmailError(false);
    setDCError(false);
    setStoreError(false);
    setHelperText("");
    setStoreHelperText("");
    setHelperEmailText("");
  };

  const onHandleChangeUser = (id) => {
    setSelectedJobber(true);
    setSelectedState({});
    setSelectedDcCode({});
    clearingForm();
    setSuccessMsg("");
    if (id !== "Add New") {
      getJobber(id);
    } else {
      setJobber({ id: "Add New", storeName: "" });
    }
  };

  //=== jobbers/stores fields validations and dc warning messages and email error
  const onchangeText = (e, type) => {
    let value = e.target.value;
    
if (type === "storeName") {
    const regex = /^[A-Za-z0-9 _-]*$/; // Allowed: letters, digits, space, underscore, hyphen
    if (!regex.test(value)) {
      setError(true); // Show error for invalid characters
      setStoreText(Name_Validation);
      return; // Stop further processing
    } else {
      setError(false);
      setStoreText("");
    }
}

    if (type === "napaStoreCode") {
      if (/^[0-9]*$/.test(value)) {
        setJobber((jobber) => ({ ...jobber, [type]: value }));
        setNapaStoreErr(false);
        setStoreError(false)
      } else {
        setNapaStoreErr(true);
        setStoreError(false)
      }
      return;
    }
    setJobber((jobber) => ({ ...jobber, [type]: value }));


    let updatedInfo = onChangeFormInfo(
      e,
      type,
      jobber,
      helperText,
      helperStoreText,
      helperEmailText,
      error,
      dcError,
      storeError
    );
    setJobber((jobber) => ({ ...jobber, ...updatedInfo.tempJobber }));
    setError(updatedInfo.error);
    setHelperText(
      updatedInfo.helperText
        ? t("tab1.messages.DC_code_msg")
        : updatedInfo.helperText
    );
    setDCError(updatedInfo.dcError);
    setStoreHelperText(
      updatedInfo.helperStoreText
        ? t("tab1.messages.store_code_msg")
        : updatedInfo.helperStoreText
    );
    setStoreError(updatedInfo.storeError);
    setHelperEmailText(
      updatedInfo.helperEmailText
        ? t("tab1.messages.email_valid_msg")
        : updatedInfo.helperEmailText
    );
    setEmailError(updatedInfo.emailError);
    setSuccessMsg("");
  };

  const onHandleChangeStates = (id) => {
    setSelectedState({ id: id, name: states[id - 1].name });
  };
  const clearError = () => {
    setError(false);
    setEmailError(false);
    setDCError(false);
    setStoreError(false);
    setErrorList({});
    setErrorList({});
  };
  const updateErrorInfo = (updatedValidationInfo) => {
    setError(updatedValidationInfo.error);
    setEmailError(updatedValidationInfo.emailError);
    setStoreError(updatedValidationInfo.storeError);
    setDCError(updatedValidationInfo.dcError);
    setErrorList(updatedValidationInfo.errorList);
  };
  const saveJobber = async () => {
    let valid = true;
    let payload = {
      ...jobber,
      country:
        selectedCountry && selectedCountry.name ? selectedCountry.name : "",
      state: selectedState && selectedState.name ? selectedState.name : "",
      id: jobber && jobber.id === "Add New" ? null : jobber.id,
      napaStoreCode: jobber.napaStoreCode ? jobber.napaStoreCode : "",
      dcCode: selectedDcCode ? selectedDcCode : "",
    };

    //store name mandatory and if email is there that should be valid
    //dc code and napa store code should be 3 digits
    //checking form validation by calling validateStoreForm function
    let updatedValidationInfo = validateStoreForm(
      error,
      emailError,
      storeError,
      dcError,
      valid,
      payload.storeName,
      helperEmailText,
      payload.napaStoreCode,
      payload.dcCode,
      errorList
    );
    updateErrorInfo(updatedValidationInfo);
    valid = updatedValidationInfo.valid;
    if (valid) {
      clearError();
      try {
        setLoading(true);
        const saveStoreData = await createStore(payload);
        //adding saved jobber to cebtral store
        dispatch(addItemInJobberData(payload));
        getAllJobbers();
        getJobber(saveStoreData.data.id);
        //association of store to Survey
        if (
          Object.keys(selectedSurvey).length === 0 &&
          selectedSurvey.constructor === Object
        ) {
          setLoading(false);
          setSuccessMsg(saveStoreData.data.message);
          clearMsg();
        } else {
          let JobberWithSurvey = {
            ...selectedSurvey,
            storeId: saveStoreData.data.id,
            surveyType: 1,
            vehicles: [],
          };
          const associateResponse = await createSurvey(JobberWithSurvey);
          const afterAssociation = await getSingleSurveyDetails(
            associateResponse.data.id
          );
          setLoading(false);
          //=== updating associated jobber and survey to store
          dispatch(addItemInsurveyData(afterAssociation.survey));
          setSuccessMsg(t("tab1.messages.store_asso_msg"));
          clearMsg();
        }
      } catch (e) {
        setLoading(false);
        alert(
          Array.isArray(e?.response?.data?.message)
            ? JSON.stringify(e?.response?.data?.message[0])
            : JSON.stringify(e?.response?.data?.message)
        );
      }
    }
  };

  const clearMsg = () => {
    setTimeout(() => {
      setSuccessMsg("");
    }, 3000);
  };

  const deleteJobber = async () => {
    if (!jobber.id || jobber.id === "Add New") {
      alert(STORE_NOT_SELECTED);
    } else {
      if (window.confirm(t("tab1.messages.store_delete_msg"))) {
        try {
          setLoading(true);
          await deleteStore(jobber.id);
          setJobber({ storeName: "" });
          setSelectedJobber(null);
          setSelectedState({});
          setSelectedDcCode({});
          setLoading(false);
          getAllJobbers();
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      }
    }
  };




  const handleDcCodeValues = (item) => {

    if (/\d/.test(item?.id)) {
      setErrorList({
        ...errorList,
        dcCodeError: { ...errorList?.dcCodeError, validationErr: true },
      });
    } else {
      setErrorList({
        ...errorList,
        dcCodeError: {
          ...errorList?.dcCodeError,
          validationErr: false,
          dataErr: false,
        },
      });
      setSelectedDcCode(item?.id);
    }
  };
  const onKeyDown = (event, key) => {
    if (key === "dcCode") {
      if (/\d/.test(event.key)) {
        setErrorList({
          ...errorList,
          dcCodeError: { ...errorList?.dcCodeError, validationErr: true, message: NUMERIC_ERR },
        });

        event.preventDefault();
      } else {
        setErrorList({
          ...errorList,
          dcCodeError: { ...errorList?.dcCodeError, validationErr: false },
        });
      }
    }
  };
  const handleBlur = (e, type) => {
    if (type === "napaStoreCode") {
      setStoreError(false);
      let value = e.target.value;
      if (value) {
        value = value.padStart(3, "0");
        setJobber((jobber) => ({ ...jobber, [type]: value }));

      }
    }
  };

  const getMultiGridForm = (data, index) => {
    return (
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {data.elements.map((item, index) => {
            return <>{getGridForm(item, index)}</>;
          })}
        </Grid>
      </Grid>
    );
  };
  const getHelperText = (key) => {
    if (key === "napaStoreCode") {
      if (storeError) return DATA_MISS
      if (napaStoreErr) return CHAR_ERR
    } else {
      return ''
    }
  }
  const hasErr = (key) => {
    let err = false
    if (key === "storeName") {
      err = error
    } else if (key === "email") {
      err = emailError
    }else if(key === "napaStoreCode"){
  err= napaStoreErr || storeError
    }else {
      err = false
    }
    return err
  }
  const getGridForm = (data, index) => {
    return (
      <React.Fragment key={index}>
        {data.fieldType === "select" && data.key === "existingStores" && (
          <SelectView
            label={data?.label}
            onHandleChange={(item) => onHandleChangeUser(item)}
            testid={data?.testid}
            data={data.key === "existingStores" && jobberList}
            value={
              data.key === "existingStores" && jobber && jobber.id
                ? jobber.id
                : ""
            }
          />
        )}

        {data.fieldType === "TextField" &&
          data.width === "fullWidth" &&
          data.key !== "selectCountry" && (
            <> <FormLabel
              htmlFor={data?.label}

              sx={{
                color: hasErr(data.key) ? "error.main" : "text.primary",
                "& .required-asterisk": {
                  color: hasErr(data.key) ? "error.main" : "inherit",
                },
              }} >
              {data?.label}
              {data?.required && <span className={"required-asterisk"}> <i>(Required *)</i></span>}
            </FormLabel>
              <TextInput
label={data?.label}
                onChange={(e) => onchangeText(e, data.key)}
                value={jobber && jobber[data.key] ? jobber[data.key] : ""}
                error={
                  data.key === "storeName"
                    ? error
                    : data.key === "email"
                      ? emailError
                      : false
                }
                helperText={error && data.key === "storeName" ?storeText?storeText: DATA_MISS : ""}
                disabled={selectedJobber ? false : true}
                type={data?.type}
                sx={data.type === "number" && NUMBER_FIELD_STYLE}
                required={data.required ? true : false}
                testid={data.testId ? data?.testId : ""}
              /></>
          )}

        {data.fieldType === "TextField" &&
          data.width === "half" &&
          data.key !== "selectCountry" && (
            <Grid item xs={6} sm={6} md={6}>
              <FormLabel
              htmlFor={data?.label}

              sx={{
                color: hasErr(data.key) ? "error.main" : "text.primary",
                "& .required-asterisk": {
                  color: hasErr(data.key) ? "error.main" : "inherit",
                },
              }} >
              {data?.label}
              
              {data?.required && <span className={"required-asterisk"}> <i>(Required *)</i></span>}
            </FormLabel>
              <TextInput
               label={data?.label}
                onChange={(e) => onchangeText(e, data.key)}
                onBlur={(e) => handleBlur(e, data.key)}
                value={jobber && jobber[data.key] ? jobber[data.key] : ""}
                error={
                  data.key === "napaStoreCode"
                    ? napaStoreErr || storeError
                    : false
                }
                helperText={getHelperText(data?.key)}

                disabled={selectedJobber ? false : true}
                type={data?.type}
                sx={data.type === "number" && NUMBER_FIELD_STYLE}
                required={data.required ? true : false}
                testid={data.testId ? data?.testId : ""}
                inputProps={data?.inputProps}
              />
            </Grid>
          )}

        {data.fieldType === "select" &&
          data.width === "half" &&
          data.key === "dcCode" && (
            <Grid item xs={6} sm={6} md={6}>
              <SelectView
                label={data?.label}
                required={data.required ? true : false}
                value={getDcValue(selectedDcCode) || ""}
                onHandleChange={(item) => handleDcCodeValues(item)}
                onKeyDown={(event) => onKeyDown(event, data.key)}
                onBlur={() => setErrorList({ ...errorList, dcCodeError: {} })}
                testid={data?.testid}
                data={dcCodeList}
                search={true}
                inputProps={data?.inputProps}
                error={
                  errorList?.dcCodeError?.validationErr ||
                  errorList?.dcCodeError?.dataErr
                }
                disabled={selectedJobber ? false : true}
                textError={
                  errorList?.dcCodeError?.validationErr
                    ? errorList?.dcCodeError?.message ||
                    data.error?.validationErr
                    : errorList?.dcCodeError?.dataErr
                      ? errorList?.dcCodeError?.message || data.error?.dataErr
                      : errorList?.dcCodeError?.message || data.error?.message
                }
              />
            </Grid>
          )}

        {data.fieldType === "TextField" &&
          data.width === "fullWidth" &&
          data.key === "selectCountry" && (
            <><FormLabel
                                          htmlFor={"selectCountry"}
                                          sx={{
                                            color:  "text.primary",
                                           
                                          }}
                                        >
                                          {data?.label}
                                         
                                        </FormLabel> <TextInput
              label={data?.label}
              defaultValue={selectedCountry && selectedCountry.name}
              disabled={selectedJobber ? false : true}
              InputProps={{
                readOnly: true,
              }}
            /></>
          )}

        {data.fieldType === "select" && data.key === "selectStates" && (
          <SelectView
            data={states}
            label={data?.label}
            testid={data?.testid}
            onHandleChange={(item) => onHandleChangeStates(item)}
            value={selectedState && selectedState.id ? selectedState.id : ""}
            disabled={selectedJobber ? false : true}
          />
        )}
      </React.Fragment>
    );
  };

  const getDcCode = async () => {
    try {
      const getDcCodeList = await getAllDcCode();
      let dcCode = [...getDcCodeList];
      setDcCodeList(dcCode);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <FormControl fullWidth>
      <Grid container>
        {STORE_CREATION_FORM_VALUES.map((data, index) => {
          return (
            <>
              {data?.label === "Multi Grid"
                ? getMultiGridForm(data, index)
                : getGridForm(data, index)}
            </>
          );
        })}
        <Grid container sx={MARGIN_TB_ITEMS_SM}>
          <Grid item md={6} lg={6} xs={12} sm={12}>
            {getMessages(
              jobber,
              helperText,
              helperStoreText,
              helperEmailText,
              successMsg
            ).map((item, index) => {
              return (
                <Typo
                  key={index}
                  testid={"successTXT"}
                  text={item.helperText}
                  style={
                    item.type === "success"
                      ? { ...HELPER_TEXT_STYLE, ...SUCCESS_TXT }
                      : HELPER_TEXT_STYLE
                  }
                />
              );
            })}
          </Grid>

          <Grid item md={6} lg={6} xs={12} sm={12}>
            <div style={{ ...RIGHT_ALIGN }}>
              <ButtonLayout
                testid="btn"
                saveLabel={"Save"}
                onClickSave={() => saveJobber()}
                saveDisabled={selectedJobber &&storeText==="" ? false : true}
                saveTestID={"save"}
                deleteLabel={"Delete"}
                deleteDisabled={!(selectedJobber && jobber?.id !== "Add New")}
                deleteOnClick={() => deleteJobber()}
                deleteTestId={"delete"}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
      {loading && (
        <Loader data-testid="loading-sppiner-id" className="Loader-style" />
      )}
    </FormControl>
  );
};
export default memo(StoreCreationForm);
